import useApi from "@/hooks/api/useApi";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import { useMemo } from "react";

interface ResponseCode {
  code: string;
}

export default function useGetReferral() {
  const userAddress = useWeb3UserAddress();
  const { path, enabled } = useMemo(
    () => ({
      path: `/user/referral/code?user=${userAddress}`,
      enabled: Boolean(userAddress),
    }),
    [userAddress]
  );

  const { data, isLoading, isError, error } = useApi<ResponseCode, ResponseCode>(
    {
      path,
    },
    {
      enabled,
      strategy: "fully-cached",
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
  };
}
